module.exports = __webpack_public_path__ + "media/images/front/common/icon_favorite-bf98d08baa1a3b749987ab09469661e2.svg";